export const EMPTY_STATE_TITLE = 'No drug test reports yet';

export const EMPTY_STATE_BODY =
  'This partner has drug testing enabled, but this candidate has no DrugTestReport rows across any recheck.';

export const EMPTY_STATE_HINT =
  'Order an A La Carte test to open Partner Dashboard and launch the modal there. On success, return here — the new report tab appears after refresh.';

export const EMPTY_STATE_CTA_LABEL = 'Request A La Carte Drug Test';

export const EMPTY_STATE_FOOTER = 'Tab visible because partner DT is enabled · candidate_tab_availability.drug_test';
